import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
  exports: [TranslateModule],
  imports: [TranslateModule.forRoot()],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateHttpLoader()
  ]
})
export class I18nModule {
  constructor(translate: TranslateService) {
    translate.addLangs(['de', 'en']);
    const browserLang = 'de';
    translate.use(browserLang.match(/de|en/) ? browserLang : 'de');
  }
}
